// src/auth/jwt.ts
import { jwtDecode, InvalidTokenError, JwtPayload } from "jwt-decode";

/** Что мы вытаскиваем из токена для приложения */
export interface ParsedJwt {
  /** Может быть строкой, числом или массивом ролей (в зависимости от провайдера) */
  role?: string | number | string[];
  /** Отображаемое имя пользователя */
  name: string;
  /** Офис/филиал, если есть в клеймах */
  officeId: number;
  /** Время истечения токена (в секундах с эпохи UNIX) */
  expSeconds: number;
}

type Claims = JwtPayload & Record<string, unknown>;

/** Безопасно достаём клеймы из токена */
export function parseUserFromJwt(accessToken: string | null | undefined): ParsedJwt {
  try {
    const claims = jwtDecode<Claims>(accessToken || "");

    const pick = (keys: readonly string[]) =>
      keys.map((k) => claims[k]).find((v) => v !== undefined);

    const role =
      pick([
        "role",
        "roles",
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role",
      ]) as ParsedJwt["role"];

    const name =
      (pick([
        "name",
        "unique_name",
        "preferred_username",
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name",
        "email",
      ]) as string | undefined) || "user";

    const officeId = Number(pick(["officeId", "office_id"])) || 0;
    const expSeconds = Number(claims.exp) || 0;

    return { role, name, officeId, expSeconds };
  } catch (e: unknown) {
    // Не шумим в консоли для InvalidTokenError, но оставляем безопасные дефолты
    if (!(e instanceof InvalidTokenError)) {
      // при необходимости можно залогировать
      // console.warn("JWT decode error:", e);
    }
    return { role: undefined, name: "user", officeId: 0, expSeconds: 0 };
  }
}
